import { today } from 'AppReact';

const holder = {
  closePropertySelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.outlet({ selectedDate: holder.selectedDate, selectedTimeOption: holder.selectedTimeOption });
      document.removeEventListener("mousedown", holder.closePropertySelector)
    }
  }
};

export default {
  init: ({ yearListRef, monthListRef, selectedYear, selectedDate }, outlet, _) => {
    yearListRef?.current?.children?.[selectedYear]?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    
    if (selectedDate?.getFullYear() === selectedYear) {
      setTimeout(function () {
        monthListRef?.current?.children?.[selectedDate.getMonth()]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      }, 800);
    }
    if (!selectedDate && today().getMonth() !== 0) {
      monthListRef?.current?.children?.[today().getMonth()]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  },
  'CustomDatePicker.Wrapper.BorderWrapper.CalendarWrapper.LeftSideWrapper.CustomButtons': ({ selectedDate, selectedTimeOption, yearListRef, monthListRef }, outlet, internalStateSetter) => {
    outlet({ selectedDate })

    const selectedYear = selectedDate?.getFullYear();
    yearListRef?.current?.children?.[selectedYear]?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    monthListRef?.current?.children?.[selectedDate.getMonth()]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });

    internalStateSetter({ selectedDate, selectedYear: selectedDate.getFullYear(), selectedTimeOption });
  },
  'CustomDatePicker.Wrapper.BorderWrapper.CalendarWrapper.LeftSideWrapper.Reset': ({ }, outlet, internalStateSetter) => {
    outlet({ selectedDate: null })
    internalStateSetter({ selectedDate: null, selectedTimeOption: null })
  },
  'CustomDatePicker.Wrapper.BorderWrapper.CalendarWrapper.RightSideWrapper.ListWrapper.YearList.Year': ({ year, monthListRef, selectedDate }, _, internalStateSetter) => {
    internalStateSetter({ selectedYear: year });

    if (selectedDate?.getFullYear() === year) {
      monthListRef?.current?.children?.[selectedDate.getMonth()]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    } else {
      monthListRef?.current?.children?.[0]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  },
  'CustomDatePicker.Wrapper.BorderWrapper.CalendarWrapper.RightSideWrapper.ListWrapper.ListWrapper.Month': ({ selectedDate, selectedTimeOption }, outlet, internalStateSetter) => {
        outlet({ selectedDate })
        internalStateSetter({ selectedDate, selectedTimeOption: 'custom' });
  }
}